import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useContext } from 'react';

import { TABLET } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { showDevNotification } from '@app/utils';

export const WorkSchedulesHeader = () => {
  const { innerWidth } = useWindowSize();
  const { showNotification } = useContext(NotificationContext);

  const isMobile = innerWidth <= TABLET;

  return (
    <>
      {isMobile ? (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={() => showDevNotification(showNotification)}
        />
      ) : (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={() => showDevNotification(showNotification)}
        >
          Выгрузить в PDF
        </Button>
      )}
    </>
  );
};
